import { Injectable, OnDestroy } from '@angular/core'
import { BehaviorSubject, distinctUntilChanged, map, Observable } from 'rxjs'
import { FeatureFlagsService } from './feature-flag.service'

export type AppPage = 'dashboard' | 'charts' | 'reports' | 'readings' | 'map' | 'watches' | 'waste'

type NavState = {
  hoveredLink: AppPage | null
}

const DEFAULT_STATE: NavState = { hoveredLink: null }
@Injectable({ providedIn: 'root' })
export class NavStore implements OnDestroy {

  private _state: BehaviorSubject<NavState> = new BehaviorSubject<NavState>(DEFAULT_STATE);
  state$ = this._state.asObservable().pipe(distinctUntilChanged());

  hoveredLink$ = this.state$.pipe(map(state => state.hoveredLink), distinctUntilChanged());

  private isReadingsFeatureEnabled: boolean
  private isReportsFeatureEnabled: boolean
  private isWatchesFeatureEnabled: boolean
  private isWasteFeatureEnabled: boolean

  private subscriptions = [
    this.featureFlagsService.readings$.subscribe(({ isEnabled })=>{
      this.isReadingsFeatureEnabled = isEnabled
    }),
    this.featureFlagsService.reports$.subscribe(({ isEnabled })=>{
      this.isReportsFeatureEnabled = isEnabled
    }),
    this.featureFlagsService.watches$.subscribe(({ isEnabled })=>{
      this.isWatchesFeatureEnabled = isEnabled
    }),
    this.featureFlagsService.waste$.subscribe(({ isEnabled })=>{
      this.isWasteFeatureEnabled = isEnabled
    }),
  ]

  constructor (
    private featureFlagsService: FeatureFlagsService
  ){}

  ngOnDestroy ():void{
    this.subscriptions.forEach(subscription=>subscription.unsubscribe())
  }

  public get state (): NavState {
    return this._state.value
  }

  setState (state: NavState): void {
    this._state.next(state)
  }

  highlightFeature (page: AppPage | null): void {
    if(page === 'readings' && !this.isReadingsFeatureEnabled) return
    if(page === 'reports' && !this.isReportsFeatureEnabled) return
    if(page === 'watches' && !this.isWatchesFeatureEnabled) return
    if(page === 'waste' && !this.isWasteFeatureEnabled) return

    this.setState({ ...this.state, hoveredLink: page  })
  }

  isLinkHovered$ (page: AppPage): Observable<boolean> {
    return this.hoveredLink$.pipe(map(hoveredLink => hoveredLink === page), distinctUntilChanged())
  }
}
